import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './EditBookingContactInfoPopup.css';
import { setShowEditBookingContactInformation } from '../../../actions/Booking';
import { sortPaymentMethods } from '../../../utils/Payments';
import ConfirmForm from '../confirmation/ConfirmForm';
import closePopupIcon from '../../../static/images/closePopupIcon.png';

// eslint-disable-next-line no-unused-vars
const EditBookingContactInfoPopup = (props, context) => {
  const popupContentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (popupContentRef.current && !popupContentRef.current.contains(event.target)) {
      props.dispatch(setShowEditBookingContactInformation(false));
    }
  };

  useEffect(() => {
    // Agregar el event listener cuando el componente se monta
    document.addEventListener('mousedown', handleClickOutside);

    // Limpiar el event listener cuando el componente se desmonta
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); // El array vacío asegura que esto solo se ejecute al montar/desmontar

  return (
    <div className="popup-overlay">
      <div className="popup-content" ref={popupContentRef}>
        <img src={closePopupIcon} alt="Close" className="popup-close"
          onClick={() => props.dispatch(setShowEditBookingContactInformation(false))}/>
        <ConfirmForm
          paymentMethods={sortPaymentMethods(props.cart.cartHotel.payment_methods)}
          isDisabled={false}
        />
      </div>
    </div>
  );
};

EditBookingContactInfoPopup.propTypes = {
  dispatch: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
};

EditBookingContactInfoPopup.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
  cart: state.cart,
}))(EditBookingContactInfoPopup);
